module.exports = __webpack_public_path__ + "static/img/tech.845db403.png";